// extracted by mini-css-extract-plugin
export default {"submenuList":"SubmenuList_submenuList__I4ydV","button":"SubmenuList_button__oB0jK"};